import type { ModelCommentThread } from '../../domain';
import { CommentMenu } from './CommentMenu';
import type { CommentPositionMap } from '../../positions';
import type { ModelCommentThreadOperation } from '../../adapter';
import type { ModelCommentId } from 'balus-common';

type Props = {
  commentThread: ModelCommentThread;
  positionMap: CommentPositionMap;
  threadOperation: ModelCommentThreadOperation;
  onEditStart(id: ModelCommentId): void;
};

export const ModelCommentMenuList: React.FC<Props> = ({
  positionMap,
  commentThread,
  threadOperation,
  onEditStart,
}: Props) => {
  const primaryComment = commentThread.getPrimaryComment();
  const regularReplyComments = commentThread.getRegularReplyComments();
  const reversedRegularReplyComments = regularReplyComments.reverse();
  return (
    <>
      {/* コメントメニューが重ならないように、位置が下のコメントから順に描画している */}
      {...reversedRegularReplyComments.map((replyComment) => (
        <CommentMenu
          key={replyComment.id}
          position={positionMap.getPosition(replyComment.id)}
          comment={replyComment}
          isPrimaryComment={false}
          threadOperation={threadOperation}
          onEditStart={onEditStart}
        />
      ))}
      <CommentMenu
        position={positionMap.getPosition(primaryComment.id)}
        comment={primaryComment}
        isPrimaryComment
        threadOperation={threadOperation}
        onEditStart={onEditStart}
      />
    </>
  );
};
